import React, { Component } from "react";

import featureFlags from '../../featureFlags';
import CardSetV3 from "./CardSetV3";
import CardSetV4 from "./CardSetV4";
import { getProfileData } from '../../data/DataStore';

import './cardSetVars.less';

class CardSetContainer extends Component {
	resolveVersion() {
		let uiOverride = getProfileData().UIVersionOverride;

		let flagSet = this.props.featureFlagsOverride
			? this.props.featureFlagsOverride : featureFlags;

		if (uiOverride === "4") {
			return 4;
		} else if (uiOverride === "3") {
			return 3;
		} else if (flagSet.novelistSelectUiVersion()) {
			return 4;
		} else {
			return 3;
		}
	}

	render() {
		let flagSet = this.props.featureFlagsOverride
			? this.props.featureFlagsOverride : featureFlags

		let resolvedVersion = this.resolveVersion(flagSet);

		if (resolvedVersion === 4)
		{
			return <CardSetV4 featureFlags={flagSet} />
		}

		return <CardSetV3 featureFlags={flagSet} />;
	}
}

export default CardSetContainer;



// WEBPACK FOOTER //
// ./src/react/card/CardSetContainer.jsx